import { UIKitTheme } from 'ui/themes/getUIKitTheme'

/* `main color` means not hover, not active, not focused, etc */
export const getMainBgColor = (theme: UIKitTheme, overColoredPad = false) => {
  if (overColoredPad) {
    return theme.uiKit.colors.global.general.transparent
  }
  return theme.uiKit.colors.global.general.transparent
}
